(() => {
  const init = () => {
    document.querySelectorAll('[data-sl-inquiry]').forEach(root => {
      if (root.dataset.enhanced) return;
      root.dataset.enhanced = 'true';
      const topic = root.querySelector('#SLTopic');
      const label = root.querySelector('[data-sl-quantity-label]');
      const quantity = root.querySelector('#SLGuests');
      const update = () => {
        const selected = topic?.selectedOptions[0]?.dataset.topic || 'general';
        root.querySelectorAll('[data-sl-topic-fields]').forEach(group => {
          const visible = group.dataset.slTopicFields.split(' ').includes(selected);
          group.hidden = !visible;
          group.querySelectorAll('input, select').forEach(input => { input.disabled = !visible; });
        });
        if (label) {
          const text = label.dataset[selected] || label.dataset.guests;
          label.textContent = text;
          if (quantity) quantity.name = `contact[${text}]`;
        }
      };
      topic?.addEventListener('change', update);
      update();
      const success = root.querySelector('[data-sl-inquiry-success]');
      success?.focus();
    });
    const openDelivery = () => {
      if (window.location.hash === '#sl-delivery') {
        const details = document.querySelector('details#sl-delivery');
        if (details) details.open = true;
      }
    };
    openDelivery();
    if (!document.documentElement.dataset.slDeliveryReady) {
      document.documentElement.dataset.slDeliveryReady = 'true';
      window.addEventListener('hashchange', openDelivery);
    }
    document.querySelectorAll('.button > span').forEach(wrapper => {
      const spans = [...wrapper.children].filter(child => child.tagName === 'SPAN');
      if (spans.length === 2 && spans[0].textContent.trim() === spans[1].textContent.trim()) spans[1].setAttribute('aria-hidden', 'true');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
